import { actions } from "../../actions/forums/forums";

export default function forums( state, action ) {
    if( !state ) {
        return {
            status: false,
        }
    }

    const newState = { ...state };

    switch( action.type ) {
        case actions.SET_FORUM_CATEGORIES: return setCategories( newState, action );
        case actions.GET_FORUM_THREADS: return getThreads( newState, action );
        case actions.SET_FORUM_THREADS: return setThreads( newState, action );
        case actions.GET_CURRENT_THREAD: return getCurrentThread( newState, action );
        case actions.SET_CURRENT_THREAD: return setCurrentThread( newState, action );
        case actions.SET_THREAD_POSTS: return setThreadPosts( newState, action );
        case actions.SET_STATUS: return handleStatus( newState, action.success );
        case actions.RESET_STATUS: return handleStatus( newState, action.success );
        // case actions.SET_REMOVE_POST_FROM_THREAD: return removePostFromThread( newState, action.post );
        // case actions.SET_REMOVE_THREAD: return removeThread( newState, action.thread );
        // case actions.SET_TAGS: return setTags( newState, action.tags );
        default: return state;
    }
}

function setCategories( newState, action ) {
    newState.categories = action.categories;
    newState.pagination = action.pagination;

    return newState;
}

function getThreads( newState, actions ) {
    newState.threads = null;
    newState.pagination = null;

    return newState;
}

function setThreads( newState, actions ) {
    newState.threads = actions.threads;
    newState.pagination = actions.pagination;

    return newState;
}

function getCurrentThread( newState, action ) {
    newState.current_thread = null;
    newState.person = null;
    return newState;
}

function setCurrentThread( newState, action ) {
    newState.current_thread = action.current_thread;
    newState.person = action.person;
    
    return newState;
}

function setThreadPosts( newState, action ) {
    newState.posts = action.posts;
    newState.pagination = action.pagination;

    return newState;
}

function handleStatus( newState, success ) {

    newState.status = success;

    return newState;
}

// function removePostFromThread( newState, post ) {
//
//
//     return newState;
// }
//
// function removeThread( newState, thread ) {
//
//
//     return newState;
// }
//
// function setTags( newState, tags ) {
//     newState.tags = tags;
//
//     return newState;
// }



// WEBPACK FOOTER //
// src/client/reducers/forums/forums.js